// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./vendor/vi-kon/laravel-admin/src/resources/assets/js-tokeninput/css/style.less
// module id = 325
// module chunks = 0